import { enumsMap } from '@/api';
import { get, post } from '@/common/request';

interface Enum {
  [key: string]: {value: string | number, label: string}[]
}

class EnumStore {
  async getList(labelList): Promise<Enum> {
    const result: { [key: string]: {value: string | number, name: string}[] } = await post(enumsMap.get('list'), { labelList }, { needCancel: false, proxyApi: '/resserv' });
    for (const key of Object.keys(result)) {
      result[key] = result[key].map(item => {
        const { name, value } = item;
        return {
          label: name,
          value
        };
      }) as any;
    }
    return result as any;
  }

  // 获取资源类目
  getCategoryList(params) {
    return get(enumsMap.get('categoryList'), params, { needCancel: false, proxyApi: '/resserv' });
  }
}

export default new EnumStore();
